import { useQuery, useQueryClient } from "@tanstack/react-query";
import http from "../services/http";

export const useAuth = () => {
  const queryClient = useQueryClient();

  // Fetch current user — cookie is sent automatically by the browser
  const getUser = async () => {
    try {
      const res = await http.get("/auth/getUser");
      return res.data.user;
    } catch (error) {
      // Not authenticated — return null to show the login page
      if ([401, 404].includes(error.response?.status)) {
        return null;
      }
      return null;
    }
  };

  const {
    data: authUser,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: ["authUser"],
    queryFn: getUser,
    staleTime: 1000 * 60 * 5,
    placeholderData: (previousData) => previousData || null,
  });

  // Sign out — ask the server to clear the cookie, then wipe local state
  const signOut = async () => {
    http.post("/auth/logout").finally(() => {
      queryClient.removeQueries(["authUser"]);
      window.location.href = "/";
    });
  };

  // Sign in — backend already set the cookie; just store the user in cache
  const signIn = (user) => {
    queryClient.setQueryData(["authUser"], user);
  };

  // Return auth state and methods
  return { authUser, signOut, signIn, isLoading, isFetching };
};
